/**
 * Sorting Constants
 * Why this matters: Centralizes magic numbers used in sorting logic to improve
 * code readability and maintainability.
 */

/**
 * Position Sorting Constants
 * Why this matters: Lower position = better ranking in search results
 * Undefined positions are treated as worst (Infinity) so they sort to the bottom
 */
export const UNDEFINED_POSITION_SCORE = Infinity;

/**
 * Volume Sorting Constants
 * Why this matters: Higher volume = better opportunity
 * Undefined volumes are treated as worst (-Infinity) so they sort to the bottom
 */
export const UNDEFINED_VOLUME_SCORE = -Infinity;

/**
 * Difficulty Sorting Constants
 * Why this matters: Lower difficulty = easier to rank
 * Undefined difficulties are treated as worst (Infinity) so they sort to the bottom
 */
export const UNDEFINED_DIFFICULTY_SCORE = Infinity;
